import React, {useEffect, useRef, useState} from "react";
import './nav_panel.css'
import logo from '../Footer/nobg.png'
// Both logos are generated by scripts/make_logos.py; rerun it whenever the logo is swapped.
import logoDark from '../Footer/nobg-dark.png'
import {useAppDispatch, useAppSelector} from "../../stateManagement/hooks";
import {FavouritesDropdownComponent} from "../../common_components/FavouritesDropdownComponent";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {api} from "../../api/userAPI";
import {logout} from "../../stateManagement/userSlice";
import {Avatar, useColorMode, useColorModeValue} from "@chakra-ui/react";
import {saveColorMode, useFollowSystemColorMode} from "../../theme";

export default function NavPanel() {
    useFollowSystemColorMode()
    const logoSrc = useColorModeValue(logo, logoDark)
    return (<nav className="navbar navbar-default w-100 m-0 nav-height-150 position-relative">

        <div className="navbar-header w-100 text-center">
            <div className="nav-logo-width">
                <Link to={"/"}><img className="img-fluid" src={logoSrc} alt="logo"/></Link></div>
        </div>
        <UserNavigation/>
    </nav>)
}


function UserNavigation() {
    const currentUser = useAppSelector(state => state.user.user)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const isMainPage = useLocation().pathname === "/"
    const {colorMode, setColorMode} = useColorMode()
    const [menuOpen, setMenuOpen] = useState(false)
    const menuRef = useRef<HTMLLIElement>(null)

    useEffect(() => {
        if (!menuOpen) return
        const onOutside = (e: Event) => {
            if (menuRef.current && !menuRef.current.contains(e.target as Node)) setMenuOpen(false)
        }
        document.addEventListener("pointerdown", onOutside)
        return () => document.removeEventListener("pointerdown", onOutside)
    }, [menuOpen])

    // Wraps a menu action so the menu closes on selection (hover alone sticks open on touch screens).
    const pick = (action: (e: any) => void) => (e: any) => {
        setMenuOpen(false)
        action(e)
    }

    function toggleTheme() {
        const next = colorMode === "dark" ? "light" : "dark"
        saveColorMode(next)
        setColorMode(next)
    }

    function LogMeOut(e: any) {
        api.logout().then(value => {
                dispatch(logout())
                navigate("/login")
            }
        )
    }
    function goToPreferences(e: any){
        navigate("/preferences")
    }
    function goHome(e: any){
        navigate("/")
    }

    return (
        <div className="nav-user-menu custom-nav">
            <ul className="nav navbar-nav flex-row mr-auto  ">
                {currentUser.user_can_manage && isMainPage ? (
                    <li id="query-user-parent" className="nav-item">
                        <FavouritesDropdownComponent/>
                    </li>
                ) : <></>}
                {/*<li id='menu-timesheets' className="nav-item">*/}
                {/*    <button type="button" data-url="menu_timesheets"*/}
                {/*        // onClick="load_menu_item($(this).attr('data-url'), $(this).parent().attr('id'));"*/}
                {/*            className=" mr-2 btn btn-outline-secondary nav-input-line-height">*/}
                {/*        <i className="ti-reload text-grey"></i>*/}
                {/*        Reload*/}
                {/*    </button>*/}
                {/*</li>*/}
                <li className="nav-item dropdown " ref={menuRef}>

                    <div className="btn btn-light nav-dropdown-style " id="navbarDropdownMenuLink" data-toggle="dropdown"
                         role="button" aria-haspopup="true" aria-expanded={menuOpen}
                         onClick={() => setMenuOpen(o => !o)}
                         title={currentUser.name}>
                        <Avatar id="username-avatar" size="sm" className="nav-avatar-style"
                             src={currentUser.avatar_url} name={currentUser.name} title={currentUser.name}/>
                        <span className="caret"/>
                    </div>
                    <div className={"dropdown-menu nav-dropdown-menu-style" + (menuOpen ? " show" : "")} aria-labelledby="navbarDropdownMenuLink">
                        <div className="dropdown-item justify-content-start pl-4" onClick={pick(goHome)}>


                            <i className="ti-home text-primary mr-2 pl-0"> </i> Home


                        </div>
                        <div className="dropdown-item justify-content-start pl-4" onClick={pick(goToPreferences)}>


                            <i className="ti-settings text-primary mr-2 pl-0"> </i> Preferences


                        </div>

                        {currentUser.user_can_administrate &&
                        <div className="dropdown-item justify-content-start pl-4" onClick={pick(event => navigate("/admin"))}>


                            <i className="ti-settings text-primary mr-2 pl-0"> </i> Admin Panel


                        </div>}
                        {currentUser.user_can_manage &&
                        <div className="dropdown-item justify-content-start pl-4" onClick={pick(event => navigate("/performance_incentive"))}>


                            <i className="ti-settings text-primary mr-2 pl-0"> </i> PI review


                        </div>
                            }
                        <div className="dropdown-item justify-content-start pl-4" onClick={pick(toggleTheme)}>
                            <i className={(colorMode === "dark" ? "bi bi-sun" : "bi bi-moon-stars") + " text-primary mr-2 pl-0"}> </i>
                            {colorMode === "dark" ? "Light mode" : "Dark mode"}
                        </div>
                        <div className="dropdown-item justify-content-start pl-4" onClick={pick(LogMeOut)}>


                            <i className="ti-power-off text-primary mr-2 pl-0"> </i> Logout


                        </div>

                    </div>

                </li>


            </ul>
        </div>
    )
}